// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{overflow-y:auto!important}.PageWithPanels.v-application.theme--light,.PageWithPanels.v-application .theme--light.v-tabs-items,.v-application .WithAccentBackgroundColor{background-color:#f5f5f5}.pointer{cursor:pointer!important}.break-word{white-space:normal;word-break:break-word}", ""]);
// Exports
module.exports = exports;
